// Accessible roving tablist for the drawer record (recordOnly) view.
// Panels stay mounted (hidden) so open editors/drafts survive tab switches.
import { RecordSectionTabs } from "../../../components/RecordSectionTabs.jsx";

export function RecordTabs({ tabs, active, onChange, idBase = "record-tab" }) {
  return <RecordSectionTabs tabs={tabs} active={active} onChange={onChange} label="Project record sections"
    testId="record-tabs" tabId={key => `${idBase}-${key}`} panelId={key => `${idBase}-panel-${key}`}
    tabTestId={key => `record-tab-${key}`} />;
}

export function RecordTabPanel({ tabKey, active, idBase = "record-tab", children }) {
  return (
    <div role="tabpanel" id={`${idBase}-panel-${tabKey}`} aria-labelledby={`${idBase}-${tabKey}`} data-testid={`record-panel-${tabKey}`}
      hidden={tabKey !== active} tabIndex={tabKey === active ? 0 : -1} style={{ outline: "none", paddingTop: 14 }}>
      {children}
    </div>
  );
}
